import { EntityDetailsModal } from '@/pages/admin/shared/entity-management/EntityDetailsModal';

type CategoryDetailsModalProps = {
	isOpen: boolean;
	onClose: () => void;
	categoryName: string;
	categoryDescription?: string | null;
	initials: string;
	iconClassName: string;
	subcategories: string[];
	onEditSubcategory: (subcategoryIndex: number) => void;
	onDeleteSubcategory: (subcategoryIndex: number) => void;
	onCreateSubcategory?: () => void;
};

export const CategoryDetailsModal = ({
	isOpen,
	onClose,
	categoryName,
	categoryDescription,
	initials,
	iconClassName,
	subcategories,
	onEditSubcategory,
	onDeleteSubcategory,
	onCreateSubcategory,
}: CategoryDetailsModalProps) => {
	return (
		<EntityDetailsModal
			isOpen={isOpen}
			onClose={onClose}
			entityName={categoryName}
			entityDescription="Detalhes e gerenciamento da categoria"
			entitySummary={categoryDescription}
			entitySummaryLabel="Descrição da categoria"
			initials={initials}
			iconClassName={iconClassName}
			listTitle="Lista de subcategorias"
			childItems={subcategories}
			emptyTitle="Nenhuma subcategoria ainda"
			emptyDescription="Use «Nova subcategoria» para adicionar à categoria."
			createChildText="Nova subcategoria"
			onEditChild={onEditSubcategory}
			onDeleteChild={onDeleteSubcategory}
			onCreateChild={onCreateSubcategory}
		/>
	);
};
